import { ChromeAppMessage } from 'Environment/ChromeApp/types';
import { ChromeAndHtml5 } from 'GlobalAppConfigService/ChromeAppHtml5/common';

const keyAppConfigSettingsExpiresIn = 'appConfigSettingsExpiresIn';
export const preHtml5LaunchMessages = ['appConfigTokenRequiredReq'];

function handleAppConfigTokenRequiredReq(message: ChromeAppMessage): void {
	const html5StoredGacsSettingsExpireTime =
		Number(localStorage.getItem(keyAppConfigSettingsExpiresIn)) || 0;
	const currentTime = Date.now();
	const isTokenRequired = html5StoredGacsSettingsExpireTime <= currentTime;

	const response: ChromeAndHtml5.AppConfigTokenRequiredResponse = {
		messageType: 'appConfigTokenRequiredRes',
		correlationId: message.payload.correlationId,
		status: ChromeAndHtml5.SUCCESS,
		isTokenRequired,
	};

	// Returning the response as an event so that our response handler code stays
	// the same and we don't add duplicate code to handle this case
	window.postMessage(response, window.location.origin);
}

// This avoids having a switch case if new messages are added
// We simpply create an Object with the message name as key and function as value
const preHtml5LaunchMessageHandlers: {
	[key: string]: (message: ChromeAppMessage) => void;
} = {
	appConfigTokenRequiredReq: handleAppConfigTokenRequiredReq,
};

export function invokeMessageHandler(message: ChromeAppMessage): void {
	preHtml5LaunchMessageHandlers[message?.header?.type]?.(message);
}
